import './UserLocationMarker.css';

interface UserLocationMarkerProps {
  lat: number;
  lng: number;
  text?: string;
}

const UserLocationMarker = (_props: UserLocationMarkerProps) => (
  <div className="user-location-marker">
    <div className="user-location-marker__pulse" />
    <div className="user-location-marker__white-border" />
    <div className="user-location-marker__dot" />
  </div>
);

export default UserLocationMarker;